import { Gender } from "@/openapi/generated";

export const STUDENT_GENDER_SELECT_OPTIONS = [
  { label: "--", value: "" },
  { label: "Female", value: Gender.Female },
  { label: "Male", value: Gender.Male },
] as const;

export function isSelectableStudentGender(
  value: unknown,
): value is typeof Gender.Male | typeof Gender.Female {
  return value === Gender.Male || value === Gender.Female;
}

/** Legacy Other cannot enroll; force a Male/Female pick on the next save. */
export function toStudentGenderFormValue(
  gender: Gender | string | null | undefined,
): typeof Gender.Male | typeof Gender.Female | "" {
  return isSelectableStudentGender(gender) ? gender : "";
}
